<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Chặng
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'code',
    headerName: $t('labels.journey'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'totalKm',
    headerName: $t('labels.kmCount'),
    valueGetter: (params: any) => {
      const { totalKm } = params.data
      return `${$formatters.formatNumber(totalKm || 0)} km`
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'internalPartner',
    headerName: $t('labels.internalPartner'),
    valueGetter: (params: any) => {
      const { type } = params.data

      if (type === 0) {
        return 'Nội bộ'
      }

      return 'Xe ngoài'
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'vehicleTypeName',
    headerName: $t('labels.vehicleType'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'vehicleLicensePlate',
    headerName: $t('labels.vehicle'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'driverName',
    headerName: $t('labels.driver'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'delay',
    headerName: $t('labels.delay'),
    valueGetter: (params: any) => {
      const { delay } = params.data
      if (delay) {
        return 'Yes'
      }
      return 'No'
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'separate',
    headerName: $t('labels.separate'),
    valueGetter: (params: any) => {
      const { separate } = params.data

      if (separate) {
        return $t('labels.true')
      }

      return $t('labels.false')
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'scheduleType',
    headerName: $t('labels.distributionAutoHandmade'),
    valueGetter: (params: any) => {
      const { scheduleType, vehicleLicensePlate } = params.data

      if (!vehicleLicensePlate) {
        return ''
      }

      if (scheduleType === 'auto') {
        return 'Điều tự động'
      }

      if (scheduleType === 'manual') {
        return 'Thủ công'
      }
    },
    filter: 'agTextColumnFilter'
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getJourney, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
